import React from 'react';
import PropTypes from 'prop-types';

import Scale11 from './Scale11';
import Text from './Text';

const Question = (props) => {
  if (props.question.type === 'scale_11') {
    return (
      <Scale11
        onClose={props.onClose}
        onOptionClick={props.onAnswer}
        title={props.question.question}
      />
    );
  }

  if (props.question.type === 'text') {
    return (
      <Text
        onSave={props.onAnswer}
        onCancel={props.onCloseAndSave}
        placeholder={props.question.question}
      />
    );
  }

  return null;
};

Question.propTypes = {
  question: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onClose: PropTypes.func.isRequired,
  onAnswer: PropTypes.func.isRequired,
  onCloseAndSave: PropTypes.func.isRequired,
};

export default Question;
